import { Box, Button } from "@modernatx-internal/component-library";
import { useRouter } from "next/router";
import React from "react";

import { ContentComponentProps, NavigationBannerContent } from "@/content-V2/types";
import { useParseLocalizedPathname } from "@/hooks/useParseLocalizedPathname";

export const NavigationBanner: React.FC<ContentComponentProps<NavigationBannerContent>> = ({
  items
}) => {
  const router = useRouter();
  const { getLocalizedPathnamesMatch } = useParseLocalizedPathname();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: ["column", null, "row"],
        gap: 4
      }}
    >
      {items.map((item, index) => {
        if (getLocalizedPathnamesMatch(item.href, router.asPath)) {
          return null;
        }

        return (
          <Box
            key={index}
            sx={{
              display: "flex",
              width: items.length <= 2 ? "50%" : "100%"
            }}
          >
            <Button
              brand="primary"
              href={item.href}
              icon="arrow-right"
              iconPosition="end"
              size="lg"
              sx={{
                justifyContent: "space-between",
                width: "100%"
              }}
              variant="outline"
            >
              {item.label}
            </Button>
          </Box>
        );
      })}
    </Box>
  );
};
